import { application } from "./application"
import DropdownController from "./dropdown_controller"
import PasswordValidationController from "./password_validation_controller"

application.register("dropdown", DropdownController)
application.register("password-validation", PasswordValidationController)
